{
    "Profile_Payment.paymentMode": "FR: Payment Mode",
    "Profile_Payment.paymentStatus": "FR: Payment Status",
    "Profile_Payment.paymentDetails": "FR: Payment details",
    "Profile_Payment.paymentAmount": "FR: Payment Amount",
    "Profile_Payment.success": "FR: Success",
    "Profile_Payment.incomplete": "FR: Incomplete",
    "Profile_Payment.paymentCompletedFullAmount": "FR: Payment Completed for full Amount",
    "Profile_Payment.downpaymentReceived": "FR: Downpayment Received",
    "Profile_Payment.bankAccountInfoSuccess": "FR: The process to capture the bank account information was successful",
    "Profile_Payment.monthlySubscriptionSuccess": "FR: The monthly subscription has been successfully created",
    "Profile_Payment.downpaymentAmount": "FR: Downpayment Amount",
    "Profile_Payment.monthlyAmount": "FR: Monthly Amount",
    "Profile_Payment.startDateMonthlyCharges": "FR: Start Date of Monthly charges",
    "Profile_Payment.failedReasonDebit": "FR: Failed Reason for Debit",
    "Profile_Payment.paymentTransfer": "FR: Payment Transfer",
    "Profile_Payment.transferDetails": "FR: Transfer Details",
    "Profile_Payment.transferredAmount": "FR: Transferred Amount",
    "Profile_Payment.transferredDate": "FR: Transferred Date",
    "Profile_Payment.transferReferenceCode": "FR: Transfer Reference Code",
    "Profile_Payment.sectionHeader": "FR: Payment",
    "Profile_Payment.formHeader": "FR: Payment Information",
    "Profile_Payment.paymentPlan": "FR: Payment Plan",
    "Profile_Payment.authorizationHeader": "FR: Authorization",
    "Profile_Payment.authorizationInformation": "FR: Authorization Information",
    "Profile_Payment.authorizedCreditCardChargeAmount": "FR: Authorized Amount",
    "Profile_Payment.authorizationStatus": "FR: Status",
    "Profile_Payment.authorizationFailedReason": "FR: Failed Reason",
    "Profile_Payment.authorizedOn": "FR: Authorized On",
    "Profile_Payment.authorizationExpiresOn": "FR: Expires On",
    "Profile_Payment.receivePaymentExpiryDate": "FR: Receive Payment Expiry Date",
    "Profile_Payment.refundHeader": "FR: Refund",
    "Profile_Payment.refundInformation": "FR: Refund Information",
    "Profile_Payment.refundDate": "FR: Refund Date",
    "Profile_Payment.refundAmount": "FR: Refund Amount",
    "Profile_Payment.refundReference": "FR: Refund Reference",
    "Profile_Payment.refundDescription": "FR: Refund Description",
    "Profile_Payment.refundMethod": "FR: Refund Method",
    "Profile_Payment.refundMethodStripe": "FR: Stripe",
    "Profile_Payment.refundMethodBankTransfer": "FR: Bank Transfer",
    "Profile_Payment.refundMethodCheck": "FR: Check",
    "Profile_Payment.refundMethodOther": "FR: Other"
}
